import { prepareToxprintsMetadata } from '@/store/toxprints'
import { prepareStdizerMetadata } from '@/store/stdizer'
import { prepareSearchMetadata } from '@/store/search'
import { prepareHazardMetadata } from '@/store/hazard'
import { prepareWebtestMetadata } from '@/store/webtest'
import { prepareOperaMetadata } from '@/store/opera'
import { prepareToddsModelsMetadata } from '@/store/toddsModels'
import { preparePfasCategoriesMetadata } from '@/store/pfasCategories'
import { prepareNccCategoriesMetadata } from '@/store/nccCategories'
import { preparePfasAtlasMetadata } from '@/store/pfasAtlas'
import { prepareArnCategoriesMetadata } from '@/store/arnCategories'
import { prepareAmenabilityMetadata } from '@/store/amenability'
import { prepareAlertsMetadata } from '@/store/alerts'
import { prepareSafetyMetadata } from '@/store/safety'
import { prepareResolverMetadata } from '@/store/resolver'

import Axios from 'axios'
import {
  ALERTS_URL,
  DESCRIPTORS_URL,
  getErrorMessage,
  HAZARD_URL,
  MORDRED_URL,
  PADEL_URL,
  RDKIT_URL,
  RESOLVER_URL,
  SAFETY_URL,
  SEARCH_URL,
  SERVICES_URL,
  STDIZER_URL,
  TOXPRINTS_URL,
  WEBTEST_URL,
} from '@/main'

import { prepareAmosMetadata } from '@/store/amos'
import { prepareChetMetadata } from '@/store/chet'
import { prepareEpiSuiteMetadata } from '@/store/epiSuite'

const state = {
  features: {},
  buildDates: {},
  descriptors: [],
}

const getters = {
  getDescriptors: (state) => {
    return state.descriptors
  },
  feature: (state) => (feature) => {
    return !!state.features[feature] && (state.features[feature].value === undefined || state.features[feature].value)
  },
  getBuildDates: (state) => (feature) => {
    return state.buildDates[feature]
  },
}

const mutations = {
  setDescriptors: (state, payload) => {
    state.descriptors = payload
  },
  setFeatures: (state, payload) => {
    state.features = { ...state.features, ...payload }
  },
  resetFeatures: (state) => {
    state.features = {}
  },
  removeFeature: (state, payload) => {
    Object.keys(payload).forEach((key) => {
      delete state.features[key]
    })
  },
  addBuildDate: (state, payload) => {
    state.buildDates = { ...state.buildDates, ...payload }
  },
  removeBuildDate: (state, payload) => {
    Object.keys(payload).forEach((key) => {
      delete state.buildDates[key]
    })
  },
}

function prepareMetadata(context) {
  Axios.get(`${DESCRIPTORS_URL}/metadata`)
    .then((response) => {
      context.commit('setDescriptors', response.data)
      context.commit('setFeatures', { descriptors: { category: 'service' } })
    })
    .catch((error) => console.warn('DESCRIPTORS module is not available: %o', getErrorMessage(error)))
  Axios.get(`${PADEL_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { padel: { category: 'service' } })
    })
    .catch((error) => console.warn('PADEL module is not available: %o', getErrorMessage(error)))
  Axios.get(`${MORDRED_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { mordred: { category: 'service' } })
    })
    .catch((error) => console.warn('MORDRED module is not available: %o', getErrorMessage(error)))
  Axios.get(`${RDKIT_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { rdkit: { category: 'service' } })
    })
    .catch((error) => console.warn('RDKIT module is not available: %o', getErrorMessage(error)))
  Axios.get(`${SERVICES_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { services: { category: 'service' } })
    })
    .catch((error) => console.warn('SERVICES module is not available: %o', getErrorMessage(error)))
}

const actions = {
  initMetadata: (context) => {
    prepareResolverMetadata(context)
    prepareHazardMetadata(context)
    prepareSafetyMetadata(context)
    prepareAmosMetadata(context)
    prepareChetMetadata(context)
    prepareEpiSuiteMetadata(context)
    prepareAlertsMetadata(context)
    prepareWebtestMetadata(context)
    prepareOperaMetadata(context)
    prepareToddsModelsMetadata(context)
    // preparePredictorMetadata(context)
    preparePfasCategoriesMetadata(context)
    prepareNccCategoriesMetadata(context)
    preparePfasAtlasMetadata(context)
    prepareArnCategoriesMetadata(context)
    prepareAmenabilityMetadata(context)
    prepareSearchMetadata(context)
    prepareStdizerMetadata(context)
    prepareToxprintsMetadata(context)
    prepareMetadata(context)
    // prepareAuthMetadata(context)
  },
  updateModuleInfo: (context) => {
    const MODULE_URLS = {
      resolver: RESOLVER_URL,
      hazard: HAZARD_URL,
      safety: SAFETY_URL,
      alerts: ALERTS_URL,
      webtest: WEBTEST_URL,
      // Predict 2.0 is now removed: predictor: PREDICTOR_URL,
      search: SEARCH_URL,
      stdizer: STDIZER_URL,
      toxprints: TOXPRINTS_URL,
    }
    Object.keys(MODULE_URLS).forEach((moduleName) => {
      const moduleUrl = MODULE_URLS[moduleName]
      Axios.get(`${moduleUrl}/version`)
        .then((response) => {
          context.commit('setFeatures', {
            [moduleName]: { category: 'module' },
          })
          context.commit('addBuildDate', {
            [moduleName]: response.data.compiled,
          })
        })
        .catch((error) => {
          console.warn(`${moduleName} module is not available: %o`, getErrorMessage(error))
          context.commit('removeFeature', { [moduleName]: {} })
          context.commit('removeBuildDate', { [moduleName]: {} })
        })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
